import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import humps from 'humps';
import CircularProgress from '@material-ui/core/CircularProgress';
import CopyButton from '../../shared/CopyButton';
import http from '../../shared/http';
import './EnhancedAdShow.scss';

import Mixpanel from '../../shared/Mixpanel';
import Export from '../EnhancedAdRtbExport/Export';

const EnhancedAdShow = props => {
  const [creative, setCreative] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    http
      .get(`/creative_previews/${props.$state.params.id}.json`)
      .then(({ data }) => {
        setIsLoading(false);
        setCreative({
          id: data.id,
          action: data.action,
          adm: data.adm,
          name: data.name,
          advertiser: data.advertiser,
          headline: data.headline,
          description: data.description,
          dsp: data.dsp,
          rtb_pixel: data.rtb_pixel,
          assetSwapUrl: data.asset_swap_url
        });
        props.CreativeService.setCreative(humps.camelizeKeys(data));
      })
      .catch(err => {
        console.error(err); // eslint-disable-line no-console
        setIsLoading(false);
      });

    Mixpanel.track('Show Enhanced Ad');
  }, []);

  const handleShareClick = () => {
    props.FlashService.push('success', 'Copied share URL to clipboard');
    Mixpanel.track('Copy Enhanced Ad share link from Show page');
  };

  if (isLoading) {
    return <CircularProgress />;
  } else if (!creative) {
    return <h4>Creative not found</h4>;
  } else {
    return (
      <Fragment>
        <div className="enhanced-ad_subform">
          <div className="enhanced-ad-show_name">{creative.name}</div>
          <div className="enhanced-ad-show_advertiser">
            {creative.advertiser}
          </div>

          <div className="enhanced-ad-show_text">
            <div className="enhanced-ad-show_label">Headline</div>
            {creative.headline}
          </div>

          {creative.description && (
            <div>
              <div className="enhanced-ad-show_label">Description</div>
              {creative.description}
            </div>
          )}

          <div className="enhanced-ad-show_share-button">
            <CopyButton
              onClick={handleShareClick}
              copyContent={window.location.href}
              buttonText="Share"
            />
          </div>
        </div>

        <Export AdMarkupService={props.AdMarkupService} creative={creative} />
      </Fragment>
    );
  }
};

EnhancedAdShow.propTypes = {
  $state: PropTypes.shape({
    params: PropTypes.object,
    go: PropTypes.func
  }).isRequired,
  CreativeService: PropTypes.shape({
    setCreative: PropTypes.func
  }).isRequired,
  FlashService: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  AdMarkupService: PropTypes.shape({ generate: PropTypes.func }).isRequired
};

export default EnhancedAdShow;
